import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { isPaidPlan, normalizePlan } from "@/lib/plans";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function AlphabotEntry() {
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/pricing", { replace: true });
      return;
    }

    axios
      .get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${token}` } })
      .then((res) => {
        const plan = normalizePlan(res.data.subscription_plan);
        const status = res.data.subscription_status || 'inactive';
        const user = JSON.parse(localStorage.getItem("user") || "{}");
        user.subscription_plan = plan;
        user.subscription_status = status;
        localStorage.setItem("user", JSON.stringify(user));

        if (isPaidPlan(plan, status)) {
          navigate("/dashboard", { replace: true });
        } else {
          navigate("/pricing", { replace: true });
        }
      })
      .catch(() => {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        navigate("/pricing", { replace: true });
      })
      .finally(() => setChecking(false));
  }, [navigate]);

  if (!checking) return null;

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center">
      <div className="w-8 h-8 border-2 border-[#00E676] border-t-transparent rounded-full animate-spin" />
    </div>
  );
}
